import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { SNItem } from './snitem';

@RegisterItem()
export class CNContactRXImage extends SNItem {
    
    public baseurl: string;

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNContactRXImage';
    }

    get filename(): string {
        return this.getProperty('Filename');
    }

    get thumbnailMedium(): string {
        return this.getProperty('Thumbnail-medium');
    }

    get thumbnail(): string {
        return this.getProperty('Thumbnail');
    }

    /**
     * factory clone
     * @returns CNContactRXImage
     */

     public clone(): any {
        return new CNContactRXImage();
    }
}
